import React, { memo, useCallback, useMemo } from 'react';

const FormField = memo(
  ({
    label,
    name,
    type = 'text',
    value,
    onChange,
    required = false,
    options = null,
    rows = null,
    placeholder = '',
    numericOnly = false,
    ...props
  }) => {
    const isNumericField = useMemo(() => {
      return (
        numericOnly ||
        [
          'numeroDocumento',
          'telefono',
          'telefonoFijo',
          'telefonoCelular',
          'telefonoFijoApoderado',
          'telefonoCelularApoderado',
        ].includes(name)
      );
    }, [name, numericOnly]);

    const handleChange = useCallback(
      (event) => {
        if (isNumericField) {
          const inputValue = event.target.value;
          const numericRegex = /^[0-9\s\-+()]*$/;

          if (numericRegex.test(inputValue)) {
            onChange(event);
          }
        } else {
          onChange(event);
        }
      },
      [onChange, isNumericField]
    );

    const fieldProps = useMemo(
      () => ({
        name,
        value: value || '',
        onChange: handleChange,
        className:
          'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500',
        required,
        placeholder,
        ...props,
      }),
      [name, value, handleChange, required, placeholder, props]
    );

    return (
      <div className='mb-4'>
        <label className='block text-sm font-medium text-gray-700 mb-1'>
          {label} {required && <span className='text-red-500'>(*)</span>}
        </label>
        {type === 'select' && options ? (
          <select {...fieldProps}>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ) : type === 'textarea' ? (
          <textarea {...fieldProps} rows={rows || 4} />
        ) : type === 'checkbox' ? (
          <input
            {...fieldProps}
            type='checkbox'
            checked={value || false}
            className='h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded'
          />
        ) : (
          <input {...fieldProps} type={type} />
        )}
      </div>
    );
  }
);

FormField.displayName = 'FormField';

export default FormField;
